 import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, Observer } from 'rxjs';
import { FromulariodespachoComponent } from './subdespacho/fromulariodespacho/fromulariodespacho.component';
import { DatoserviciosComponent } from './subdespacho/datoservicios/datoservicios.component';
import { EquiposComponent } from './subdespacho/equipos/equipos.component';
import { ServiciosactivosComponent } from './subdespacho/serviciosactivos/serviciosactivos.component';
import { AgregarConsultaPacienteComponent } from 'app/modals/agregar-consulta-paciente/agregar-consulta-paciente.component';
import { MatDialog } from '@angular/material/dialog';
import { get } from 'https';
import { Router } from '@angular/router';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { navigation } from 'app/navigation/navigation';
@Component({
  selector: 'app-despacho',
  templateUrl: './despacho.component.html',
  styleUrls: ['./despacho.component.scss']
})
export class DespachoComponent implements OnInit {

  public isActive = 0;

  constructor(private dialog: MatDialog, private _router: Router) {
  }

  ngOnInit() {
  }

  public get esDespacho() : boolean {
    return this._router.isActive('/despacho/form-despacho',false) as boolean;
  }

  agregarConsulta(){
    this.dialog.open(AgregarConsultaPacienteComponent,{
        width:'95%',
        height:'100%',
        maxWidth:'100%'
    });
  }
}


